import EventEmitter from "eventemitter3";

const myEmitter = new EventEmitter();

export default myEmitter;
